import { 
    gql, 
    useMutation, 
    ApolloError 
} from "@apollo/client";

import { 
    CreateAdminMutationMutation,
    CreateAdminMutationMutationVariables, 
    Error
} from "../../../../../schemaTypes";

export const CREATE_ADMIN_MUTATION = gql`
  mutation CreateAdminMutation(
    $input: CreateAdminInput!
  ) {
    createAdmin(
      input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: CreateAdminMutationMutationVariables & { 
            profilePictureFile?: File 
        }
      ) => Promise<{
        errors: Error[] | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
      message?: string;
    }
  ) => React.ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const CreateAdminController: React.FC<Props> = ({ children, onMessage }) => {
  const [createAdminMutation, { loading, error }] = useMutation<
    CreateAdminMutationMutation, 
    CreateAdminMutationMutationVariables
  >(CREATE_ADMIN_MUTATION);
 
const submit = async (
  values: CreateAdminMutationMutationVariables & { profilePictureFile?: File }
): Promise<{
  errors: Error[] | null;
  message?: string;
}> => {
  const { profilePictureFile, ...rest } = values;

  let profilePictureUrl = rest.input.profilePictureUrl;

  if (profilePictureFile) {
    profilePictureUrl = await fileToBase64(profilePictureFile);
  }

  const result = await createAdminMutation({
    variables: {
      ...rest,
      input: {
        ...rest.input,
        profilePictureUrl,
      },
    },
  });

  const createAdmin = result.data?.createAdmin;

  // ✅ Ensure correct error shape
  const errors: Error[] | null =
    createAdmin?.errors && createAdmin.errors.length > 0
      ? createAdmin.errors
      : null;

  if (createAdmin?.message && onMessage) {
    onMessage(createAdmin.message);
  }

  return {
    errors,
    message: createAdmin?.message || undefined,
  };
};

 
  return children({ 
    submit, 
    loading, 
    error 
  });
};